<template>
  <div
    :class="{
      'w-full': true,
      'absolute top-35px z-50 -ml-5 border-t-0 bg-www-color-white p-13px pl-5 pt-1 shadow-[0_8px_8px_-4px_rgba(0,0,0,0.25)]':
        !mobile,
      'mt-3': mobile,
    }"
  >
    <p
      :class="{
        'text-11px font-bold leading-3 text-www-color-black': true,
        'text-www-color-white': mobile,
      }"
    >
      {{ aiAdvisor.message }}
    </p>
    <div
      :class="{
        'mt-3 flex flex-col gap-2': true,
      }"
    >
      <PTCLink
        v-for="suggestion in aiAdvisor.suggestions"
        :key="suggestion"
        href="#"
        role="button"
        :class="{
          'cursor-pointer text-11px font-medium leading-none text-www-color-primary-light': true,
        }"
        @click.prevent="$emit('select', suggestion)"
        @keydown.space.prevent="$emit('select', suggestion)"
      >
        {{ suggestion }}
      </PTCLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import PTCLink from '~/components/Atmos/PTCLink/PTCLink.vue';
import type { HeaderAiAdvisor } from '~/sanity/types';

defineProps<{
  mobile?: boolean;
  aiAdvisor: HeaderAiAdvisor;
}>();

defineEmits<{
  select: [suggestion: string];
}>();
</script>
